export const PACKAGING_UNIT = {
  MG: {
    SMALL_PACKAGE: 'dose',
    BIG_PACKAGE: 'bigdose',
  },
  kg: {
    SMALL_PACKAGE: 'sac',
    BIG_PACKAGE: 'bigbag',
  },
}

export function computeProductNeeds(
  surface: number | undefined = 0,
  density: number | undefined = 0,
  pmg: number | undefined = 0,
) {
  const resultInMG = surface * density * 10
  const resultInKG = (surface * density * pmg) / 100

  return {
    MG: resultInMG,
    kg: resultInKG,
  }
}

function computeNumberOfPackages(quantity, measureQuantityBigPackage, measureQuantitySmallPackage) {
  const numberOfBigPackage =
    measureQuantityBigPackage && !measureQuantitySmallPackage
      ? Math.ceil(quantity / measureQuantityBigPackage)
      : undefined
  const numberOfSmallPackage = measureQuantitySmallPackage
    ? Math.ceil(quantity / measureQuantitySmallPackage)
    : undefined
  const numberOfBigPackageInMix =
    measureQuantityBigPackage && measureQuantitySmallPackage
      ? Math.floor(quantity / measureQuantityBigPackage)
      : undefined
  const numberOfSmallPackageInMix = numberOfBigPackageInMix
    ? Math.ceil((quantity % measureQuantityBigPackage) / measureQuantitySmallPackage)
    : undefined
  return {
    numberOfBigPackage,
    numberOfSmallPackage,
    numberOfBigPackageInMix,
    numberOfSmallPackageInMix,
  }
}

export function packagingConvert(packagingOptions, calculationResult) {
  if (packagingOptions.keys().next().done) return false

  return Object.keys(calculationResult).reduce((acc, packagingType) => {
    const measureQuantityBigPackage = packagingOptions.get(PACKAGING_UNIT[packagingType].BIG_PACKAGE)?.quantity
    const measureQuantitySmallPackage = packagingOptions.get(PACKAGING_UNIT[packagingType].SMALL_PACKAGE)?.quantity

    return {
      ...acc,
      [packagingType]: computeNumberOfPackages(
        calculationResult[packagingType],
        measureQuantityBigPackage,
        measureQuantitySmallPackage,
      ),
    }
  }, {})
}
